import _typeof from "@babel/runtime/helpers/typeof";
export var isSideText = function isSideText(side) {
  return !!(side && _typeof(side) === 'object' && ('title' in side || 'subTitle' in side));
};
export var isIconComponent = function isIconComponent(component) {
  if (_typeof(component) === 'object' && component) {
    var keys = Object.keys(component);
    return keys.includes('render') && !keys.includes('props');
  }
  return false;
};
export var isSideRenderable = function isSideRenderable(side) {
  var disabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (typeof side === 'function') {
    return !!side(disabled);
  }
  return !!side;
};